"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const analytics_1 = require("./analytics");
const scriptTagHtml = (apiKey) => {
    return `var plantrack=plantrack||[];!function(){for(var t=["init","identify","track"],\
a=function(t){return function(){plantrack.push([t].concat(Array.prototype.slice.call(arguments,0)))}},\
n=0;n<t.length;n++)plantrack[t[n]]=a(t[n])}(),\
plantrack.load=function(t,a){plantrack._endpoint=t,a&&plantrack.init(a);\
var n=document.createElement("script");n.type="text/javascript",n.async=!0,\
n.src="https://app.planhat.com/analytics/plantrack.min.js";\
 var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(n,r)};\
 plantrack.load("https://analytics.planhat.com/analytics/${apiKey}");`;
};
const envToPlanhatApiKey = {
    development: '',
    staging: '',
    production: '30155190-3266-456b-88fa-f86be4da9d90'
};
const objectCircularReplacer = () => {
    const seen = new WeakSet();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (_key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
const mapEventAttritubtes = (eventAttributes) => {
    return (0, mapValues_1.default)(eventAttributes, value => {
        if (Array.isArray(value)) {
            return value.join(',');
        }
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value);
            }
            catch (e) {
                return JSON.stringify(value, objectCircularReplacer());
            }
        }
        return value;
    });
};
class PlanhatService {
    constructor() {
        this.isInitialized = false;
    }
    get apiKey() {
        return this.options
            ? envToPlanhatApiKey[this.options.environment]
            : undefined;
    }
    get logger() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.logger) !== null && _b !== void 0 ? _b : console;
    }
    initialize({ environment, getBaseAttributesFunc, enabled = true }) {
        this.options = { environment, getBaseAttributesFunc, enabled };
        if (!this.options.enabled) {
            return;
        }
        if (typeof window !== 'undefined' && this.apiKey) {
            const script = document.createElement('script');
            script.innerHTML = scriptTagHtml(this.apiKey);
            document.body.appendChild(script);
            this.isInitialized = true;
        }
    }
    setUserId(userId) {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.enabled)) {
            return;
        }
        // @ts-ignore
        if (this.isInitialized && plantrack) {
            // @ts-ignore
            plantrack.identify(userId); // eslint-disable-line
            this.userId = userId;
        }
    }
    clearUser() {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.enabled)) {
            return;
        }
        // @ts-ignore
        if (this.isInitialized && plantrack) {
            // @ts-ignore
            plantrack.identify(null); // eslint-disable-line
            this.userId = null;
        }
    }
    trackEvent(eventName, eventAttributes, planhatMajorAttributes = []) {
        var _a, _b, _c;
        try {
            const planhatEventName = [
                eventName,
                ...planhatMajorAttributes
                    .map(attr => {
                    const attributeValue = eventAttributes[attr];
                    return attributeValue && String(attributeValue);
                })
                    .filter(Boolean)
            ].join('-');
            if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.enabled)) {
                this.logger.debug(`Reporting Planhat event ${planhatEventName}`, eventAttributes, planhatMajorAttributes);
                return;
            }
            // @ts-ignore
            if (!this.isInitialized || !plantrack || !this.userId) {
                return;
            }
            const eventInfo = Object.assign(Object.assign({}, mapEventAttritubtes(eventAttributes)), (_c = (_b = this.options) === null || _b === void 0 ? void 0 : _b.getBaseAttributesFunc) === null || _c === void 0 ? void 0 : _c.call(_b, analytics_1.AnalyticsServices.PLANHAT));
            // @ts-ignore
            plantrack.track(planhatEventName, { info: eventInfo }); // eslint-disable-line
        }
        catch (err) {
            this.logger.error(`Error sending event '${eventName}' to Planhat`, err);
        }
    }
}
exports.default = new PlanhatService();
//# sourceMappingURL=planhatService.js.map